module.exports = __webpack_public_path__ + "img/user-red.fe0d0b7d.svg";